import React from 'react'
import { Link, NavLink } from 'react-router-dom'

export default function NavItem({ name, url }) {
  return (
    <NavLink style={({ isActive }) => ({
      color: isActive ? '#fff' : null,
      background: isActive ? '#f1b634' : null,
    })} 
    className='flex flex-row font-bold text-white hover:bg-gray-300 hover:text-gray-900 p-2 rounded transition-all duration-200' to={url}>{name}</NavLink>
  )
}
